import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import App from './App';

import Amplify from "aws-amplify";
import config from "./awsConfig";

Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID
    },
    Storage: {
      region: config.s3.REGION,
      bucket: config.s3.BUCKET,
      identityPoolId: config.cognito.IDENTITY_POOL_ID
    },
    // API: {
    //   endpoints: [
    //       {
    //         name: "settings",
    //         endpoint: config.apiGateway.URL,
    //         region: config.apiGateway.REGION
    //       },
    //       {
    //         name: "teachers",
    //         endpoint: config.apiGateway.URL,
    //         region: config.apiGateway.REGION
    //       },
    //     {
    //       name: "users",
    //       endpoint: config.apiGateway.URL,
    //       region: config.apiGateway.REGION
    //     },
    //     {
    //       name: "listsettings",
    //       endpoint: config.apiGateway.URL,
    //       region: config.apiGateway.REGION
    //     },
    //   ]
    // }
  });


ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
